export default __webpack_public_path__ + "static/media/new-user.f6139058.png";